import axios from '@/utils/api.request'
let previousUrl = '/api'

export const getDefaultTableData = (data) => {
  return axios.request({
    url: `${previousUrl}/cases/export`,
    data: data,
    method: 'post'
  })
}

// 分页
export const getTableData = (pageSize, pageNumber, queryData) => {
  return axios.request({
    url: `${previousUrl}/cases/export?page=${pageNumber}&size=${pageSize}&sort=Id,desc&sort=status,asc`,
    data: queryData,
    method: 'post'
  })
}

export const getOptions = (id) => {
  return axios.request({
    url: `${previousUrl}/cases/${id}`,
    method: 'get'
  })
}

export const getArealist = () => {
  return axios.request({
    url: `${previousUrl}/arealist`,
    method: 'get'
  })
}
export const getArealist2 = (data) => {
  return axios.request({
    url: `${previousUrl}/user/leaders/${data}`,
    method: 'get'
  })
}
export const getArealist1 = () => {
  return axios.request({
    url: `${previousUrl}/arealistforexcel`,
    method: 'get'
  })
}

export const getLeader = () => {
  return axios.request({
    url: `${previousUrl}/user/leaders`,
    method: 'get'
  })
}

export const pushCases = (data) => {
  return axios.request({
    url: `${previousUrl}/Example/cases2Example`,
    method: 'post',
    data: data
  })
}
